export default __webpack_public_path__ + "static/osica-1c40b5136bef3115e6870032643f8b58.jpg";